module.exports = __webpack_public_path__ + "static/media/harmon-hall-yellow.a50d742a.svg";